exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/_wks-ext.js
// module id = 584
// module chunks = 168707334958949